module.exports = __webpack_public_path__ + "static/media/banner_2.eea44e28.png";